import { formatarDentes, parseDentes, type EtiquetaUnica } from "@bookdental/schemas";
import { entregaDoPedido } from "@/components/prosthesis/endereco-de-entrega";
import { rotuloDoMaterialDoServico } from "@/components/prosthesis/rotulo-do-material";
import type { ProsthesisServiceRow } from "@/components/prosthesis/types";
import type { IncomingOrderRow } from "./production-types";
import type { PedidoDaEtiqueta, ServicoDaEtiqueta } from "./etiquetas";
import { paginaUnica, urlDoPedido } from "./etiqueta-unica";

export const POPUP = "O navegador bloqueou a janela de impressão. Libere pop-ups para este site.";

/** Dentes em ordem numérica (o pedido guarda na ordem do clique: "26, 12, 21…"); arcada inteira
 *  continua virando o rótulo. Texto que não é dente (digitado à mão) sai como veio. */
export function dentesDaEtiqueta(teeth: string | null): string | null {
  const lista = parseDentes(teeth);
  if (lista.length === 0) return teeth;
  return formatarDentes([...lista].sort((a, b) => Number(a) - Number(b)));
}

export const paraEtiqueta = (s: ProsthesisServiceRow): ServicoDaEtiqueta => ({
  ordem: s.ordem,
  servico: s.serviceCategory.label,
  material: rotuloDoMaterialDoServico(s) ?? null,
  dentes: dentesDaEtiqueta(s.teeth),
  cor: s.shadeOption?.code ?? null,
  observacao: s.notes,
  etapa: s.productionStage?.label ?? null,
  tecnico: s.assignedToUser?.name ?? null,
});

export const pedidoDaEtiqueta = (order: IncomingOrderRow): PedidoDaEtiqueta => ({
  id: order.id,
  numero: order.numero,
  paciente: order.patientName,
  dentista: order.dentistName,
  clinica: order.organization.isPersonal ? null : order.organization.name,
  prazo: order.deadline,
  criadoEm: order.createdAt,
});

/** Etiquetas únicas do pedido: uma por serviço (ou só a do serviço pedido). */
export const paginaUnicaDoPedido = (cfg: EtiquetaUnica, order: IncomingOrderRow, logo: string | null, servico?: ProsthesisServiceRow, urlDoCatalogo?: string | null) =>
  paginaUnica(cfg, pedidoDaEtiqueta(order), (servico ? [servico] : order.services).map(paraEtiqueta), entregaDoPedido(order), urlDoPedido(order.id), logo, urlDoCatalogo);
